/**
 * Size Chart Unit Switcher Component
 * Handles switching between CM and Inches for body measurements
 */
class SizeChartUnitSwitcher extends HTMLElement {
  connectedCallback() {
    this.initializeSwitcher();
  }

  initializeSwitcher() {
    const tabs = this.querySelectorAll('.size-chart__unit-tab');
    const contents = this.querySelectorAll('.size-chart__measurement-content');

    if (!tabs.length || !contents.length) {
      return;
    }

    // Set initial state
    const activeUnit = this.getAttribute('data-active-unit') || 'inches';
    this.switchUnit(activeUnit, tabs, contents);

    // Add click listeners to tabs
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const unit = tab.getAttribute('data-unit');
        if (unit) {
          this.switchUnit(unit, tabs, contents);
        }
      });
    });
  }

  /**
   * Switches the active unit and updates tab/content visibility
   * @param {string} unit - The unit to switch to ('cm' or 'inches')
   * @param {NodeList} tabs - All tab elements
   * @param {NodeList} contents - All content elements
   */
  switchUnit(unit, tabs, contents) {
    // Update tab states
    tabs.forEach(tab => {
      const isActive = tab.getAttribute('data-unit') === unit;
      tab.classList.toggle('size-chart__unit-tab--active', isActive);
      tab.setAttribute('aria-pressed', isActive.toString());
    });

    // Update content visibility
    contents.forEach(content => {
      const contentUnit = content.getAttribute('data-unit');
      const isActive = contentUnit === unit;
      
      if (isActive) {
        content.classList.remove('size-chart__measurement-content--hidden');
      } else {
        content.classList.add('size-chart__measurement-content--hidden');
      }
    });

    // Store active unit for persistence
    this.setAttribute('data-active-unit', unit);
  }
}

// Register the custom element
if (!customElements.get('size-chart-unit-switcher')) {
  customElements.define('size-chart-unit-switcher', SizeChartUnitSwitcher);
}

